@if(component){
<div class="flex flex-justify-center p-t-12 p-b-12">
    <div class="c-6 c-12-m c-12-s m-b-0"
         [ngClass]="component.align">
        <p class="h2"
           *iCms="'title' of component; content 'html'"></p>
        <p class="h3 m-t-8 m-t-7-m m-t-7-s"
           *iCms="'subtitle' of component; content 'html'"></p>
        <p class="p1 m-t-8 m-t-7-m m-t-7-s"
           *iCms="'copy' of component; content 'html'"></p>
    </div>
</div>
}
